import React, { useEffect } from 'react'
import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, Button, Image } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import Cache from '@fs/zion-cache'
import FullNameWelcome from './FullNameWelcome.svg'

export default function WelcomeOverlay({ welcomeOverlay, goBackToGive }) {
  const cache = new Cache({ storeName: 'RIP_settings' })
  useEffect(() => {
    cache.getItem('shownWelcome').then((shownWelcome) => {
      if (!shownWelcome) {
        welcomeOverlay.handleClick()
        cache.setItem('shownWelcome', true)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/exhaustive-deps -- only needs to be run once
  }, [])

  const [t] = useTranslation()
  return (
    <DialogOverlay {...welcomeOverlay} title={t('full-name-welcome-overlay.title', 'Welcome to Full Name Review')}>
      {t(
        'full-name-welcome-overlay.content',
        'A computer indexed this image, and we need your help to make sure the full name is highlighted, spelled correctly, and in the right order.'
      )}
      <Image
        src={FullNameWelcome}
        alt={t('full-name-welcome-overlay.title', 'Welcome to Full Name Review')}
        height={140}
        noCrop
      />
      {t(
        'full-name-welcome-overlay.content2',
        'Reviewing names makes research easier and helps people find their ancestors every day!'
      )}
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={goBackToGive}>{t('full-name-welcome-overlay.go-back.btn', 'Go Back')}</Button>
          <Button onClick={() => welcomeOverlay.close()} emphasis="high">
            {t('full-name-welcome-overlay.start.btn', 'Start')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
